import makeRequest from './base.request'

export const getIndicadorEscola = async (inIndicator) => {
    try {
        const response = await makeRequest.get(`indicador/escola?indicator=${inIndicator}`);

        var indicador = response.periodos[0];
        return indicador;
    } catch (error) {
        console.error(error);
    }
}

export const getIndicadorSerie = async (inIndicator) => {
    try {
        const response = await makeRequest.get(`indicador/serie?indicator=${inIndicator}`);

        var indicador = response.periodos[0];
        return indicador;
    } catch (error) {
        console.error(error);
    }
}

export const getIndicadorTipoSimulado = async (inIndicator) => {
    try {
        const response = await makeRequest.get(`indicador/tiposimulado?indicator=${inIndicator}`);

        var indicador = response.periodos[0];
        return indicador;
    } catch (error) {
        console.error(error);
    }
}
